import React, { useState } from "react";
import { Trans, useTranslation} from "react-i18next";

export const PlansList = ({ moduleList, appList, languageList, featuresList}) => {
  const MAX_ITEMS = 3;

  const [showMoreModules, setShowMoreModules] = useState(false);
  const [showMoreApps, setShowMoreApps] = useState(false);
  const [showMoreLanguages, setShowMoreLanguages] = useState(false);

  const { t } = useTranslation();

  const handleShowMore = (type) => {
    if (type === 'modules') {
      setShowMoreModules(true);
    } else if (type === 'apps') {
      setShowMoreApps(true);
    } else if (type === 'languages') {
      setShowMoreLanguages(true);
    }
  };

  const styleOnClick = {cursor: 'pointer', fontStyle: "italic", fontSize:"0.9em" }

  const moreMessage = "..More";

  return (
    <div className="pricing-table-content">
      {featuresList && featuresList.length > 0 ? 
      <>
        <ul className="my-1 px-0">
            {featuresList.map(feature => (
                <li key={feature?.id}>
                  <i className={`${feature?.icon}`}/>
                  <span className="ml-2"><Trans>{feature?.name}</Trans></span>
                </li>
            ))}
        </ul>
      </> 
      :
      <>
      {moduleList?.length > 0 && <span><strong><Trans>Modules</Trans></strong></span>}
      <ul className="px-0 my-1">
        {moduleList?.slice(0, showMoreModules ? moduleList.length : MAX_ITEMS).map(feature => (
          <li key={feature.id} >{feature.content_object_data?.name === "HR" ? t("HR Payroll") : t(feature.content_object_data?.name)}</li>
        ))}
        {moduleList?.length > MAX_ITEMS && !showMoreModules &&
          <li onClick={() => handleShowMore('modules')} style={styleOnClick}>
            <Trans>{moreMessage}</Trans>
          </li>
        }
      </ul>

      {appList?.length > 0 && <span><strong><Trans>Applications</Trans></strong></span>}
      <ul className="px-0 my-1">
        {appList?.slice(0, showMoreApps ? appList.length : MAX_ITEMS).map(feature => (
          <li key={feature.id}><Trans>{feature.content_object_data?.name}</Trans></li>
        ))}
        {appList?.length > MAX_ITEMS && !showMoreApps &&
          <li onClick={() => handleShowMore('apps')} style={styleOnClick}>
            <Trans>{moreMessage}</Trans>
          </li>
        }
      </ul>

      {languageList?.length > 0 && <span><strong><Trans>Languages</Trans></strong></span>}
      <ul className="px-0 my-1">
        {languageList?.slice(0, showMoreLanguages ? languageList.length : MAX_ITEMS).map(feature => (
          <li key={feature.id}><Trans>{feature.content_object_data?.name}</Trans></li>
        ))}
        {languageList?.length > MAX_ITEMS && !showMoreLanguages &&
          <li onClick={() => handleShowMore('languages')}  style={styleOnClick}>
            <Trans>{moreMessage}</Trans>
          </li>
        }
      </ul>
      </>
      }
    </div>
  );
};
